import { RichText } from "components/RichText";
import styles from "./OverviewIntro.module.css";

export const OverviewIntro = ({ description, title }) => (
  <div className={styles.container}>
    <RichText>
      <h1>{title}</h1>
      <p className="smallLead">{description}</p>
    </RichText>
  </div>
);
